export default function goToTop() {
    const container = document.querySelector('.js-go-to-top');
    const button = container.querySelector('button');
    const siteWrapper = document.querySelector('.main-wrapper');

    // Show or hide the button based on scroll position
    function toggleVisibility() {
        if (window.scrollY > 300) {
            container.classList.remove('is-hidden');
        } else {
            container.classList.add('is-hidden');
        }
    }

    button.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(() => {
            siteWrapper.focus();
        }, 50);
    });

    window.addEventListener('scroll', toggleVisibility);
}
